import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { patientsStorage } from '../../services/localStorage.service';
import './PatientRegister.css';

const PatientRegister = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [patients, setPatients] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadPatients = () => {
      setIsLoading(true);
      try {
        let allPatients = patientsStorage.getAll();
        
        // Apply search filter
        if (searchTerm) {
          allPatients = patientsStorage.search(searchTerm);
        }
        
        // Apply date range filter if provided
        if (startDate || endDate) {
          allPatients = allPatients.filter(patient => {
            const admitDate = patient.admit_date || patient.admitDate;
            if (!admitDate) return false;
            
            const patientDate = new Date(admitDate).toISOString().split('T')[0];
            if (startDate && patientDate < startDate) return false;
            if (endDate && patientDate > endDate) return false;
            return true;
          });
        }
        
        setPatients(allPatients);
      } catch (error) {
        console.error('Error loading patients:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadPatients();
  }, [searchTerm, startDate, endDate]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2,
    }).format(amount || 0);
  };


  const displayPatients = patients.map(patient => {
    const totalBill = parseFloat(patient.total_bill || patient.totalBill || 0);
    const paidAmount = parseFloat(patient.paid_amount || patient.paidAmount || 0);
    const remainingAmount = totalBill - paidAmount;
    
    return {
      id: patient.id,
      name: patient.patient_name || patient.patientName,
      admitDate: patient.admit_date || patient.admitDate || '-',
      dischargeDate: patient.discharge_date || patient.dischargeDate || '-',
      totalBill: formatCurrency(totalBill),
      paidAmount: formatCurrency(paidAmount),
      remainingAmount: formatCurrency(remainingAmount),
      notes: patient.notes || '-'
    };
  });

  return (
    <div className="patient-register">
      <div className="patient-register-header">
        <h1 className="page-title">Patient Register</h1>
        <button className="btn btn-primary" onClick={() => navigate('/create-patient')}>+ Add New Patient</button>
      </div>

      <div className="patient-register-filters">
        <div className="search-section">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search by patient name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="form-input"
            />
            <button className="btn btn-secondary" style={{ backgroundColor: 'transparent', color: '#14b8a6', border: '1px solid #14b8a6' }}>
              Search
            </button>
          </div>
          <div className="date-range">
            <label>Date Range:</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="form-input"
            />
            <span>-</span>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="form-input"
            />
            <button className="btn btn-secondary" style={{ backgroundColor: 'transparent', color: '#14b8a6', border: '1px solid #14b8a6' }}>
              Filter
            </button>
          </div>
        </div>
      </div>

      <div className="patient-register-table-card">
        <table className="table">
          <thead>
            <tr>
              <th>PATIENT NAME</th>
              <th>ADMIT DATE</th>
              <th>DISCHARGE DATE</th>
              <th>TOTAL BILL</th>
              <th>PAID AMOUNT</th>
              <th>REMAINING AMOUNT</th>
              <th>NOTES</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                  Loading patients...
                </td>
              </tr>
            ) : displayPatients.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                  No patients found
                </td>
              </tr>
            ) : (
              displayPatients.map((patient) => (
              <tr key={patient.id}>
                <td>{patient.name}</td>
                <td>{patient.admitDate}</td>
                <td>{patient.dischargeDate}</td>
                <td>{patient.totalBill}</td>
                <td>{patient.paidAmount}</td>
                <td className={parseFloat(patient.remainingAmount.replace(/[₹,]/g, '')) > 0 ? 'remaining-red' : ''}>
                  {patient.remainingAmount}
                </td>
                <td>{patient.notes}</td>
              </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PatientRegister;

